import Image from "next/image";

interface BrandLogoProps {
  /** "icon" — тільки квадратна іконка; "full" — логотип з текстом */
  variant?: "icon" | "full";
  /** Висота в пікселях (ширина рахується автоматично по пропорції) */
  height?: number;
  className?: string;
}

export function BrandLogo({
  variant = "icon",
  height = 40,
  className = "",
}: BrandLogoProps) {
  const v = process.env.NEXT_PUBLIC_ASSET_VERSION ?? "dev";

  if (variant === "full") {
    // viewBox 300×72 → ширина = height * 300/72
    const width = Math.round((height * 300) / 72);
    return (
      <Image
        src={`/logo.svg?v=${v}`}
        alt="steampeek"
        width={width}
        height={height}
        className={`object-contain flex-shrink-0 ${className}`}
        priority
      />
    );
  }

  // icon: квадрат 72×72
  return (
    <Image
      src={`/logo-icon.svg?v=${v}`}
      alt="steampeek"
      width={height}
      height={height}
      className={`object-contain flex-shrink-0 ${className}`}
      priority
    />
  );
}
